import { presentations as presentationsApi } from "apis-v2/callables";
import type { IPresentationLink } from "common/interfaces";

import ApiAdapter from "./apiAdapter";

class PresentationsLinksAdapter extends ApiAdapter<IPresentationLink, { presentationId: string }> {
    get presentationId() {
        return this._additionalProps.presentationId;
    }

    get _removeAllowed() {
        return true;
    }

    async _createApi(_model: IPresentationLink): Promise<IPresentationLink> {
        throw new Error("Not supported, use dedicated api endpoint directly instead");
    }

    async _updateApi(
        changesetUpdates: Partial<IPresentationLink>, changesetOriginal: Partial<IPresentationLink>
    ): Promise<Partial<IPresentationLink>> {
        const { modifiedAt, _changeId } = await presentationsApi.updateLink({
            id: this.presentationId,
            linkId: this.id,
            changesetOriginal,
            changesetUpdates,
            _changeId: this.model.attributes._changeId,
        });
        return { modifiedAt, _changeId };
    }

    async _getApi() {
        return await presentationsApi.getLink({
            id: this.presentationId,
            linkId: this.id,
        });
    }

    async _removeApi() {
        await presentationsApi.deleteLink({
            id: this.presentationId,
            linkId: this.id,
        });
    }

    _composeModel(baseModel: Partial<IPresentationLink>): IPresentationLink {
        return { ...baseModel, id: this.id } as IPresentationLink;
    }

    _getPusherChannelId(): string | null {
        return `private-presentation-link-${this.id}`;
    }
}

export default PresentationsLinksAdapter;
